// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"247":"dc91a677","992":"c60cdc97"}[chunkId] + ".chunk.js");